import { getAvailableTokens } from '@/api/base';

const state = {
  accessToken: undefined,
  user: {},
  applyInfo: null,
  forceChangePwd: false,
  availableTokens: Number.MAX_SAFE_INTEGER,
};

const getters = {
  accessToken: (state) => state.accessToken,
  user: (state) => state.user,
  isAuthenticated: (state) => !!state.accessToken,
  hasAccess: (state, getters, rootState, rootGetters) => {
    const isSaas = rootGetters['common/isSaas'];
    return isSaas ? Boolean(state.user?.publicMetadata?.activate) : !!state.accessToken;
  },
  publicMetadata: (state) => state.user?.publicMetadata,
  publicEmail: (state) => state.user?.emailAddresses?.[0]?.emailAddress || '',
  applyInfo: (state) => state.applyInfo,
  isAdmin: (state, getters, rootState, rootGetters) => {
    const isSaas = rootGetters['common/isSaas'];
    return isSaas ? state.user?.publicMetadata?.roles?.some((role) => role.includes('admin')) : !!state.accessToken;
  },
  forceChangePwd: (state) => state.forceChangePwd,
  availableTokens: (state) => state.availableTokens,
};

const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
  },
  setUser(state, user) {
    state.user = user;
  },
  setApplyInfo(state, applyInfo) {
    state.applyInfo = applyInfo;
  },
  setForceChangePwd(state, forceChangePwd) {
    state.forceChangePwd = forceChangePwd;
  },
  setAvailableTokens(state, availableTokens) {
    state.availableTokens = availableTokens;
  },
};

const actions = {
  setAccessToken({ commit }, accessToken) {
    commit('setAccessToken', accessToken);
  },
  setUser({ commit }, user) {
    commit('setUser', user);
  },
  setApplyInfo({ commit }, applyInfo) {
    commit('setApplyInfo', applyInfo);
  },
  setForceChangePwd({ commit }, forceChangePwd) {
    commit('setForceChangePwd', Boolean(forceChangePwd));
  },
  updateAvailableTokens({ commit }) {
    return getAvailableTokens().then((res) => {
      commit('setAvailableTokens', res.availableTokens);
    });
  },
};

export default { state, getters, mutations, actions };
